import { GroupElementInteractors } from '../tool/interactors';
import { GROUP_ELEMENT_CLASSID } from './io/Types';
import { VisibilityMode } from '../RoomManager';
import { Util } from '../utils/Util';
import { ElementCategory, GroupElement as Base, UndoOperation } from '@egr/wcf/modules/core/mdl';
import { ElementChangedFlags } from '@egr/wcf/modules/core/mdl';
import { MainArticleElement, ArticleElement } from '@egr/wcf/modules/cf';
import { removeElement, contains } from '@egr/wcf/modules/utils/array';
import { serializeVector3, serializeQuaternion, deserializeVector3, deserializeQuaternion } from '@egr/wcf/modules/core/io';
export class GroupElement extends Base {
    constructor(pRoomManager) {
        super(pRoomManager.app.model);
        this.mRoomManager = pRoomManager;
        this.mScene = pRoomManager.app.model.scene;
        this.mIdStr = Util.HashString();
        this.mInteractors = new GroupElementInteractors(this.mRoomManager, this);
        this.mElements = new Array();
        this.mVisible = true;
        this.mHandleTansformationChange = true;
        this.mPendingTransformMatrix = null;
        this.mNode.name = GroupElement.SELF_NAME_ID;
        this.mNode.id = GroupElement.SELF_NAME_ID;
        this.mUpdateDepth = 0;
        _projectContext = null;
        if (this.mNode != null)
            this.mNode.freezeWorldMatrix();
    }
    get category() {
        return (ElementCategory.None);
    }
    get elements() {
        return (this.mElements);
    }
    get elementCount() {
        return (this.mElements.length);
    }
    get type() {
        return ("GroupElement");
    }
    get isVisible() {
        return (this.mVisible);
    }
    get Id() {
        return (this.mIdStr);
    }
    get childElements() {
        return (this.mElements);
    }
    canTranslate() {
        return (true);
    }
    canRotate() {
        return (true);
    }
    // public canSelect(): boolean
    // {
    //     return (true);
    // }
    canSelectSubElement() {
        return (true);
    }
    showInteractors(pShow) {
        this.mInteractors.showInteractors(pShow);
    }
    dispose() {
        super.dispose();
        this.mElements = [];
    }
    clone(pNewParent) {
        let tClone = new GroupElement(this.mRoomManager);
        tClone.node.parent = pNewParent != null ? pNewParent : null;
        tClone.copyDataFrom(this);
        let tWMorigin = this.mNode.computeWorldMatrix();
        tClone.setTransform(tWMorigin);
        for (let tElement of this.mElements) {
            let tnewClone = tElement.clone();
            if (tnewClone != null) {
                tnewClone.node.position = tElement.node.position.clone();
                if (tElement.node.rotationQuaternion != null) {
                    tnewClone.node.rotationQuaternion = tElement.node.rotationQuaternion.clone();
                }
                tnewClone.updateTransformation();
                this.mRoomManager.app.model.removeElement(tnewClone, false, false);
                this.mRoomManager.app.model.addElement(tnewClone, tClone.node);
                tClone.addElement(tnewClone);
                tnewClone.getMainElement = () => tClone;
                // add listener to update element (transformation) after property was changed
                if (tnewClone instanceof MainArticleElement)
                    tnewClone.eventPropertiesChanged.addListener(tClone.ElementPropertiesChanged(tnewClone));
            }
        }
        tClone.eventAdded.addListener(() => tClone.afterClone());
        return (tClone);
    }
    addElement(pElement) {
        this.mElements.push(pElement);
    }
    removeElement(pElement) {
        if (contains(this.mElements, pElement)) {
            removeElement(this.mElements, pElement);
        }
    }
    updateGeometry() {
        for (let tElement of this.mElements) {
            if (tElement instanceof MainArticleElement)
                tElement.updateGeometry();
            if (tElement instanceof GroupElement)
                tElement.updateGeometry();
        }
    }
    saveUndoData(pOperation) {
        return (this._saveUndoData());
    }
    loadUndoData(pOperation, pUndoData) {
        this._loadUndoData(pUndoData);
        if (pOperation === UndoOperation.Transform)
            this.mRoomManager._removeTransformedElement(this);
    }
    isSelectionHighlightEnabled() {
        return (true);
    }
    getChildrenOfTypeMainArticles() {
        let tList = [];
        for (let tElement of this.mElements) {
            if (tElement instanceof MainArticleElement) {
                tList.push(tElement);
                continue;
            }
            if (tElement instanceof GroupElement) {
                let tGroupChilds = tElement.getChildrenOfTypeMainArticles();
                tList = tList.concat(tGroupChilds);
                continue;
            }
        }
        return (tList);
    }
    getSelectionHighlightBoundingBox() {
        if (this.mRoomManager.visibilityMode === VisibilityMode.Show2d) {
            let tBounds = this.boundingBox.clone();
            tBounds.max.y = 0.001;
            return (tBounds);
        }
        return (this.boundingBoxVisible);
    }
    getProperties() {
        let tPromise = super.getProperties().then((pProperties) => {
            let tProperties = pProperties;
            if (tProperties == null)
                tProperties = new Array();
            return (tProperties);
        });
        return (tPromise);
    }
    serialize(pContext) {
        let tIOGroup = {};
        tIOGroup.classId = GROUP_ELEMENT_CLASSID;
        tIOGroup.position = serializeVector3(this.node.position);
        tIOGroup.level = this.getNodeLevel();
        if (this.mNode.rotationQuaternion != null)
            tIOGroup.rotation = serializeQuaternion(this.mNode.rotationQuaternion);
        _projectContext = pContext;
        if (this.mElements.length > 0) {
            tIOGroup.elements = [];
            for (let tElement of this.mElements) {
                if (tElement != null) {
                    let tIONode = tElement.serialize(_projectContext);
                    tIOGroup.elements.push(tIONode);
                }
            }
        }
        return (tIOGroup);
    }
    ElementPropertiesChanged(pElement) {
        return () => {
            if (pElement == null)
                return;
            if (this.mUpdateDepth !== 0)
                return;
            this.mUpdateDepth++;
            pElement.updateTransformation();
            this.mUpdateDepth--;
        };
    }
    //// internal //////////////////////////////////////////////////////////////////////////////
    /** @internal */
    _saveUndoData() {
        let tData = {};
        return (tData);
    }
    /** @internal */
    _loadUndoData(pData) {
        if (pData == null)
            return;
    }
    /** @internal */
    _interactionFinished() {
        //
    }
    /** @internal */
    _finishLoading(pIOGroup) {
        if (pIOGroup == null)
            return;
    }
    /** @internal */
    _updateVisibility() {
        //update selection bounds
        this.notifyChange(ElementChangedFlags.BoundingBox);
    }
    /** @internal */
    _finishTransformation() {
        if (this.mPendingTransformMatrix == null)
            return;
        this.mPendingTransformMatrix = null;
    }
    /** @internal */
    static _registerClass(pRoomManager) {
        pRoomManager.app.model.registerElementLoader(GROUP_ELEMENT_CLASSID, (pApp, pContext, pIOElement) => {
            return (GroupElement.deserialize(pRoomManager, pContext, pIOElement));
        });
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    handleImmediateChanges() {
        super.handleImmediateChanges();
    }
    handleDelayedChanges() {
        super.handleDelayedChanges();
        if (this.wasFlagChanged(ElementChangedFlags.Transformation) && this.mHandleTansformationChange) {
            if (this.mRoomManager._transformationStarted()) {
                this.mPendingTransformMatrix = this.transform.clone();
                this.mRoomManager._addTransformedElement(this);
            }
            else
                this.updateTransformMatrix(); // reset transform
        }
    }
    copyDataFrom(pElement) {
        super.copyDataFrom(pElement);
        if (pElement == null || !(pElement instanceof GroupElement))
            return;
        if (pElement.node.rotationQuaternion != null) {
            this.mNode.rotationQuaternion = pElement.node.rotationQuaternion.clone();
        }
    }
    afterClone() {
        //
    }
    updateTransformMatrix() {
        this.mHandleTansformationChange = true;
    }
    getNodeLevel() {
        let tRes = 0;
        let tparent = this.mNode.parent;
        while (tparent != null) {
            tRes++;
            tparent = tparent.parent;
        }
        return (tRes);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    static deserialize(pRoomManager, pContext, pIOElement) {
        if (pIOElement == null)
            return (null);
        let tIOGroup = pIOElement;
        let tGroup = null;
        if (tIOGroup.elements.length > 0) {
            tGroup = new GroupElement(pRoomManager);
            tGroup.node.position = deserializeVector3(tIOGroup.position);
            if (tIOGroup.rotation != null) {
                tGroup.node.rotationQuaternion = deserializeQuaternion(tIOGroup.rotation);
            }
        }
        for (let tElement of tIOGroup.elements) {
            let t_Element = tElement;
            let tLoader = pRoomManager.app.model.mLoaders.get(t_Element.classId);
            if (tLoader != null) {
                let tserialElement = tLoader(pRoomManager.app, pContext, t_Element, null);
                if (tserialElement != null && tGroup != null) {
                    if (!(tserialElement instanceof GroupElement))
                        pRoomManager.app.model.addElement(tserialElement);
                    pRoomManager.app.model.removeElement(tserialElement, false, false);
                    pRoomManager.app.model.addElement(tserialElement, tGroup.node);
                    tGroup.addElement(tserialElement);
                    tserialElement.eventPropertiesChanged.addListener(tGroup.ElementPropertiesChanged(tserialElement));
                    tserialElement.getMainElement = () => tGroup;
                    tserialElement.notifyChange(ElementChangedFlags.Transformation);
                    tserialElement.updateTransformation();
                    if (tserialElement instanceof ArticleElement)
                        tserialElement.updateGeometry();
                }
            }
        }
        if (tGroup != null) {
            tGroup.updateTransformation();
        }
        return (tGroup);
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
GroupElement.SELF_NAME_ID = "room_GroupElement";
//// temp variables ////////////////////////////////////////////////////////////////////////////
var _projectContext = null;
